<template>
    <div class="CampaignList">
        <div class="d-flex align-center justify-space-between header-page">
            <div class="page-title">
                {{ $f.tc('campaignList') }}
                <v-icon color="#96ADD0" size="26" class="icon-refresh" @click="refresh">refresh</v-icon>
            </div>
            <v-layout align-center justify-end>
                <div v-if="isAdmin()" class="btn-custom" @click="$router.push('/campaign/form')">
                    <img src="/img/add.svg" alt="icon-add" style="transform: scale(1.2); margin-right: 8px">
                    {{ $f.tc('add') + ' ' + $t('campaign') }}
                </div>
            </v-layout>
        </div>
        <v-container
            v-show="!isShowLoading"
            fluid class="fci-scrollbar"
            style="padding: 15px 20px !important; height: calc(100vh - 123px); overflow-y: auto"
        >
            <div v-if="!isHasCampaigns" class="centerXY" style="flex-direction: column; height: 100%">
                <img src="/img/contact-admin.svg" alt="icon-contact-admin" style="width: 200px">
                <div class="mt-10 no-permissions">{{ $f.tc('notGrantedCampaignsOrBots', {nameArea: $t('campaign')}) }}</div>
                <div class="no-permissions">{{ $f.tc('contactAdminCampaignOrBot', {nameArea: $t('campaign')}) }}</div>
                <div class="btn-custom mt-20" @click="refresh">
                    <v-icon color="#FFFFFF" size="20" class="mr-6">refresh</v-icon>
                    {{ $f.tc('refresh') }}
                </div>
            </div>
            <div v-else>
                <v-layout align-center justify-end>
                    <div style="width: 250px">
                        <v-select
                            :placeholder="$f.tc('status')"
                            v-model="filter.status"
                            :items="statusList"
                            clearable outlined
                            class="input-custom"
                            @input="searchNow('')"
                        >
                            <template v-slot="item">
                                <!-- HTML that describe how select should render items when the select is open -->
                                {{ $f.tc(`campaignStatus.${item.text.toLowerCase()}`) }}
                            </template>
                        </v-select>
                    </div>
                    <div style="margin-left: 6px; width: 250px">
                        <v-select
                            :placeholder="$f.tc('direction')"
                            v-model="filter.direction"
                            :items="directionList"
                            clearable outlined
                            class="input-custom"
                            @input="searchNow('')"
                        ></v-select>
                    </div>
                    <div style="margin-left: 6px; width: 250px">
                        <search-campaign
                            :keyword="filter.search"
                            @input="searchNow($event)"
                            @campaign-selected="viewCampaign($event)"
                            class="search-custom">
                        </search-campaign>
                    </div>
                </v-layout>
                <SimpleDataTable
                    :headers="headers"
                    :items="items"
                    :pagination.sync="pagination"
                    @row-click="viewCampaign($event)"
                >
                    <template v-slot:action="props">
                <span class="row-actions">
                    <v-btn icon small @click.stop="viewCampaign(props.item)" class="mx-0">
                        <img src="/img/view-blue.svg" alt="icon-view" style="transform: scale(0.95);">
                    </v-btn>
                    <template v-if="isOwnerOrAdmin(props.item.permissions)">
                        <v-btn icon small class="mx-0" @click.stop="editCampaign(props.item)">
                            <img src="/img/edit-blue.svg" alt="icon-edit">
                        </v-btn>
                        <v-btn icon small class="mx-0" @click.stop="deleteItem(props.item)">
                            <img src="/img/delete-blue.svg" alt="icon-delete" style="transform: scale(1.1);">
                        </v-btn>
                        <v-btn icon small class="mx-0" @click.stop="openManagePermissionEditor(props.item)">
                            <img src="/img/permission.svg" alt="icon-permission">
                        </v-btn>
                    </template>
                </span>
                    </template>
                </SimpleDataTable>
            </div>
        </v-container>
        <CampaignEditor ref="CampaignEditor" :on-saved="refresh"></CampaignEditor>
        <ManagePermissionEditor ref="ManagePermissionEditor"></ManagePermissionEditor>
    </div>
</template>
<script>
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'
import CampaignEditor from '@/views/Campaign/CampaignEditor'
import ManagePermissionEditor from '@/views/Campaign/ManagePermissionEditor'
import SearchCampaign from '@/views/Campaign/Form/SearchCampaign'
import CampaignService from '@/services/campaign.service'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'
import { mapState } from 'vuex'
import lodash from 'lodash'

export default {
    name: 'CampaignList',
    mixins: [RoleMixin],
    components: {
        SimpleDataTable,
        CampaignEditor,
        ManagePermissionEditor,
        SearchCampaign
    },
    data() {
        return {
            directionList: [
                {text: 'INBOUND', value: 'INBOUND'},
                {text: 'OUTBOUND', value: 'OUTBOUND'}
            ],
            statusList: this.$const.campaign.statusList,
            filter: {
                status: '',
                direction: '',
                search: ''
            },
            items: [],
            pagination: {
                page: 1,
                rowsPerPage: 10
            },
            isHasCampaigns: false
        }
    },
    computed: {
        ...mapState({
            isShowLoading: state => state.isShowLoading
        }),
        headers() {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'title'
                },
                {
                    text: this.$t('status'),
                    value: 'status'
                },
                {
                    text: this.$t('direction'),
                    value: 'direction'
                },
                {
                    text: this.$t('owner'),
                    value: 'owner'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom'
                }
            ])
        }
    },
    mounted() {
        // Perform get all to check if the user has assigned any campaign => update isHasCampaigns,
        // then filter according to the query
        this.validateQueryURL()
        this.refresh(false).then(() => {
            let query = this.$utils.cloneObject(this.$route.query)
            if (Object.keys(query).length > 0) {
                this.pagination.page = query.page ? query.page : 1
                delete query.page
                this.filter = {...this.filter, ...query}
                this.refresh()
            } else {
                this.$appService.hideLoading()
            }
        }).catch(this.$appService.hideLoading)
    },
    beforeDestroy() {
        this.$store.dispatch(this.$actionTypes.campaign.RESET_SERVICE_NUMBER_CALLED)
    },
    methods: {
        openManagePermissionEditor(campaign) {
            this.$refs.ManagePermissionEditor.open(campaign)
        },
        refresh(isHideLoading = true) {
            this.$appService.showLoading()
            return CampaignService.getCampaigns(
                this.pagination.rowsPerPage,
                this.pagination.page,
                null,
                this.filter.search,
                this.filter.status,
                this.filter.direction
            ).then(
                result => {
                    this.items = result.data.data
                    this.pagination.totalItems = result.data.count
                    if (result.data.data.length > 0) {
                        this.isHasCampaigns = true
                    }
                }
            ).finally(() => {
                if (isHideLoading) {
                    this.$appService.hideLoading()
                }
            })
        },
        searchNow(keyword) {
            this.pagination.page = 1
            this.filter.search = keyword
            this.refresh()
        },
        editCampaign(item) {
            this.$router.push({path: '/campaign/form', query: {campaignId: item.id}})
        },
        deleteItem(item) {
            this.$appService.confirm(this.$t('confirmDelete', {item: item.title})).then(
                () => {
                    const i18n = {
                        action: this.$t('delete'),
                        item: this.$t('campaign')
                    }
                    CampaignService.deleteCampaign(item).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                            this.refresh()
                        }
                    )
                }
            )
        },
        viewCampaign(campaign) {
            this.$router.push('/campaign/' + campaign.id)
        },
        validateQueryURL () {
            let query = this.$utils.cloneObject(this.$route.query)
            let allow_queries = ['status', 'direction', 'search', 'page']
            let keys = Object.keys(query)
            keys.forEach(key => {
                if (!allow_queries.includes(key)) {
                    delete query[key]
                }
            })
            if (!lodash.isEqual(query, this.$route.query)) {
                this.$router.replace({
                    query: query
                })
            }
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            let crrQuery = this.$utils.cloneObject(this.$route.query)
            if (newPage !== 1) {
                crrQuery.page = newPage
            } else {
                delete crrQuery.page
            }
            this.$router.replace({
                query: crrQuery
            })
            this.refresh()
        },
        'pagination.rowsPerPage': 'refresh',
        filter: {
            deep: true,
            handler: function (newFilter) {
                let query = this.$utils.cloneObject(this.$route.query)
                query = {...query, ...newFilter}
                if (!query.status) {
                    delete query.status
                }
                if (!query.direction) {
                    delete query.direction
                }
                if (!query.search) {
                    delete query.search
                }
                this.$router.replace({
                    query: query
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.header-page {
    background: #FFFFFF;
    border-bottom: 1px solid #E4EDFA;
    padding: 0 20px;
    flex-wrap: wrap;
    height: 63px;
}

.page-title {
    color: #12274F;
    font-size: 22px;
    font-weight: 700;
    flex: 1 !important;
    padding: 10px 0;
}

.icon-refresh {
    cursor: pointer;
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            margin-bottom: 4px !important;
        }
    }
}

.search-custom {
    ::v-deep {
        .v-input__slot {
            margin-bottom: 16px !important;
        }
    }
}

.title-chart {
    line-height: 30px;
    height: 30px;
    font-size: 16px;
    font-weight: 700;
}

.no-permissions {
    font-size: 14px;
    color: #545253;
    text-align: center;
}

::v-deep {
    .v-menu {
        display: none !important;
    }

    .v-input__slot {
        background: #FFFFFF;
        padding: 0 10px !important;
        border-radius: 5px !important;
        border: 1px solid #D9D9D9;
        font-size: 14px !important;
        height: 30px;
    }

    .v-input__slot:after {
        border: none !important;
    }

    .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: none !important;
    }

    .v-input.v-text-field .v-label--active {
        background: #FFFFFF !important;
        top: 8px !important;
        left: -3px !important;
        padding: 0 4px;
        color: #617CA5 !important;
        font-size: 11px !important;
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field .v-input__append-inner {
        margin-top: 4px !important;
    }
}
</style>
